// src/components/ProductFinder/ProductFinder.jsx

import React from 'react';
import { FaSearch } from 'react-icons/fa';
import './ProductFinder.css';

function ProductFinder({ 
  searchQuery, 
  onSearchChange, 
  categories, 
  onCategorySelect, 
  activeCategory,
  // --- YENİ PROPS ---
  brands,
  onBrandSelect,
  activeBrand,
  priceRange,
  onPriceChange
}) {
  return (
    <div className="product-finder-container">
      <p className="finder-prompt">NE ARAMIŞTINIZ?</p>
      
      {/* Arama Çubuğu */}
      <div className="search-bar-wrapper">
        <input
          type="text"
          placeholder="Ürün, marka veya kategori arayın..."
          value={searchQuery}
          onChange={onSearchChange}
        />
        <button className="search-icon-btn" aria-label="Ara">
          <FaSearch />
        </button>
      </div>

      {/* --- YENİ: Fiyat Aralığı Inputları --- */}
      <div className="price-range-inputs">
        <input 
          type="number" 
          name="min" // HomePage'deki state key'i ile aynı
          placeholder="Min Fiyat (TL)" 
          value={priceRange.min}
          onChange={onPriceChange} 
          min="0"
        />
        <span className="price-separator">-</span>
        <input 
          type="number" 
          name="max" // HomePage'deki state key'i ile aynı
          placeholder="Max Fiyat (TL)" 
          value={priceRange.max}
          onChange={onPriceChange} 
          min="0"
        />
      </div>
      
      {/* Kategori Butonları */}
      <div className="category-buttons">
        {categories.slice(0, 4).map(cat => (
          <button
            key={cat.id}
            className={`category-btn ${activeCategory === cat.name ? 'active' : ''}`}
            onClick={() => onCategorySelect(cat.name)} 
          >
            {cat.name}
          </button>
        ))}
      </div>

      {/* --- YENİ: Marka Butonları/Logoları --- */}
      {/* Markalar için ayrı bir bölüm */}
      <div className="brand-buttons">
        <p className="filter-label">Markaya Göre Filtrele:</p>
        {brands.map(brand => (
          <button
            key={brand.id}
            className={`brand-btn ${activeBrand === brand.id ? 'active' : ''}`}
            onClick={() => onBrandSelect(brand.id)}
          >
            {/* Varsa logo, yoksa isim */}
            {/* <img src={`/images/logos/${brand.id}.png`} alt={brand.name} /> */}
            {brand.name}
          </button>
        ))}
      </div>

    </div>
  );
}

export default ProductFinder;